import FormattedPrice from '../Utilities/FormattedPrice';
import { GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { useSelector } from 'react-redux';
import { LEFT_GRID_SIZE, RIGHT_GRID_SIZE } from 'payments-checkout-lib/constants/Sizes';
import { Flex } from 'foundations-components/components/Flex';
import { getTaxCalculationId } from '../../state/calculateTaxSlice';
import { OPEN } from '../../constants/Statuses';
import TaxBreakdowns from './TaxBreakdowns';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CalculateAtCheckoutTaxes = ({
  session,
  currencyCode
}) => {
  const taxCalculationId = useSelector(getTaxCalculationId);
  const taxRate = session.subtotalsPublicResponse.subtotalsTaxRate;
  const calculatedTaxAmount = session.subtotalsPublicResponse.firstPaymentTaxAmount;
  const hasAstWithTaxesCalculatedPreviously = session.status !== OPEN && session.isAutomatedSalesTaxEnabled && !taxCalculationId;
  const hasCalculatedTaxAmount = (taxCalculationId || hasAstWithTaxesCalculatedPreviously) && typeof calculatedTaxAmount === 'number';
  const taxBreakdowns = session.subtotalsPublicResponse.taxBreakdowns || [];
  if (taxBreakdowns.length) {
    return /*#__PURE__*/_jsx(TaxBreakdowns, {
      currencyCode: currencyCode,
      taxBreakdowns: taxBreakdowns,
      taxesCalculatedAtCheckout: true
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: LEFT_GRID_SIZE,
      marginBlockStart: "200",
      children: /*#__PURE__*/_jsx(Text, {
        as: "h6",
        textAlign: "start",
        children: hasCalculatedTaxAmount ? /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "center",
          children: [taxRate ? /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.taxWithRate",
            options: {
              taxRate
            }
          }) : /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.tax"
          }), /*#__PURE__*/_jsx(Badge, {
            use: "pantera",
            marginInlineStart: "100",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "payments.taxFinal"
            })
          })]
        }) : /*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "center",
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.tax"
          }), /*#__PURE__*/_jsx(HelpIcon, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "payments.taxNotCalculatedTooltip"
            }),
            marginInlineStart: "100"
          })]
        })
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      marginBlockStart: "200",
      "data-test-id": "calculate-at-checkout-taxes",
      size: RIGHT_GRID_SIZE,
      children: hasCalculatedTaxAmount ? /*#__PURE__*/_jsx(Text, {
        textAlign: "end",
        typography: "body-125",
        children: /*#__PURE__*/_jsx(FormattedPrice, {
          currencyCode: currencyCode,
          price: calculatedTaxAmount
        })
      }) : /*#__PURE__*/_jsx(Flex, {
        justifyContent: "end",
        children: /*#__PURE__*/_jsx(Badge, {
          marginInlineStart: "100",
          use: "pantera",
          textWrap: "nowrap",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.taxNotCalculated"
          })
        })
      })
    })]
  });
};
export default CalculateAtCheckoutTaxes;